/**
 * Shared state for the Advertise components
 * This file contains variables that need to be shared between
 * the listing and detail views
 */

// Flag to track navigation within the Advertise section
let isNavigatingWithinAdvertise = false;

// Flag to determine if filters should be reset
let shouldResetFilters = true;

// Local storage key for filter persistence
const FILTER_STORAGE_KEY = 'advertise_filter_state';

// Helper functions to manage the navigation flag
export const setNavigatingWithinAdvertise = (value: boolean) => {
  isNavigatingWithinAdvertise = value;
  
  // Store in session storage to retain across page reloads
  try {
    sessionStorage.setItem('advertise_navigating_within', value ? 'true' : 'false');
  } catch (error) {
    console.error('Error saving navigation state to sessionStorage', error);
  }
};

export const getNavigatingWithinAdvertise = () => {
  // First try to retrieve from sessionStorage (to handle page reloads)
  try {
    const stored = sessionStorage.getItem('advertise_navigating_within');
    if (stored !== null) {
      return stored === 'true';
    }
  } catch (error) {
    console.error('Error reading navigation state from sessionStorage', error);
  }
  
  return isNavigatingWithinAdvertise;
};

// Helper functions to manage the filter reset flag
export const setShouldResetFilters = (value: boolean) => {
  shouldResetFilters = value;
  
  // Store in session storage to retain across page reloads
  try {
    sessionStorage.setItem('advertise_should_reset_filters', value ? 'true' : 'false');
  } catch (error) {
    console.error('Error saving filter reset state to sessionStorage', error);
  }
};

export const getShouldResetFilters = () => {
  // First try to retrieve from sessionStorage (to handle page reloads)
  try {
    const stored = sessionStorage.getItem('advertise_should_reset_filters');
    if (stored !== null) {
      return stored === 'true';
    }
  } catch (error) {
    console.error('Error reading filter reset state from sessionStorage', error);
  }
  
  return shouldResetFilters;
}; 

// Function to check if filter data exists in localStorage
export const hasStoredFilters = (): boolean => {
  try {
    return localStorage.getItem(FILTER_STORAGE_KEY) !== null;
  } catch (error) {
    console.error('Error checking for stored filters', error);
    return false;
  }
};

// Export FILTER_STORAGE_KEY for consistency
export { FILTER_STORAGE_KEY }; 